module.exports = __webpack_public_path__ + "media/img/label-ico-ruby-7708091d.png";